import { table } from './_table';
import { show } from './show';
import { page_import } from './import';

export const databases = {
  namespaced: true,
  modules: {
    table,
    show,
    import: page_import
  }
};
